module.exports = __webpack_public_path__ + "static/media/logo-parlement-live.5e8bd600.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/logo-parlement-live.jpg
// module id = 1556
// module chunks = 0